import { Observable } from 'rxjs';
import { BasiqUserCustomerMapping, BasiqManageConsentRequest, Verify2FaCodeToIndividualRequest } from '../basiq.domain';
import { ApiResponse, PayloadApiResponse } from '../types.domain';
import { BankStatementData } from '../bank.domain';
 


export type GetBasiqCustomerMappingFn = (reference: string) => Observable<PayloadApiResponse<BasiqUserCustomerMapping | null>>;
export type GetBasiqStatementDataForCompanyFn = (params: BasiqUserCustomerMapping) => Observable<PayloadApiResponse<BankStatementData | null>>;
export type GetBasiqAuthLinkFn = (id: string) => Observable<PayloadApiResponse<string | null>>;
export type RefreshBasiqConnectionsFn = (userId: string, type: 'business' | 'consumer') => Observable<ApiResponse>;
export type GetBasiqManageConsentLinkFn = (abn: string) => Observable<PayloadApiResponse<string | null>>;
export type Send2FaCodeToBusinessUserFn = (request: BasiqManageConsentRequest) => Observable<PayloadApiResponse<{mobileNumber: string, email: string} | null>>;
export type Verify2FaCodeToIndividualFn = (request: Verify2FaCodeToIndividualRequest) => Observable<ApiResponse>;

export interface BasiqCategoryDetailsTableData {
    date: string;
    description: string;
    credit: number;
    debit: number;
    id: string;
}